import { Component, inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';

import { TranslateModule } from '@ngx-translate/core';
import { ScoDialogModule } from '@schueco/schueco-ui-components';

@Component({
  selector: 'dc-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.css'],
  imports: [TranslateModule, ScoDialogModule],
  standalone: true,
})
export class ErrorPopupComponent {
  dialogRef = inject<DialogRef<ErrorPopupComponent>>(DialogRef);
  data = inject<{
    status: string;
    message: string;
  }>(DIALOG_DATA);

  close() {
    this.dialogRef.close();
  }

  closeDialogClicked() {
    this.dialogRef.close();
  }
}
